interface Venue {
  internalName?: string | null;
  name: string;
}

export const sortVenuesByName = (a: Venue, b: Venue) =>
  (a.internalName || a.name).localeCompare(b.internalName || b.name);
